import {
  CCPPricingPlanContent,
  CCPPricingPlanItem,
  CCPPricingPlanTier,
  PricingStrategy,
  PricingTier
} from '@atlassiansox/asc-product-catalog';
import { PricingPlan, PricingPlans } from '.';
import { PricingPeriod } from '../models';

const HAMS_PRICING_STRATEGY_BY_CCP_PRICING_POLICY = {
  ['VOLUME']: PricingStrategy.FIXED_COST,
  ['GRADUATED']: PricingStrategy.MARGINAL_PER_UNIT
};

const convertCCPPricingStrategyToHAMS = (
  ccpPricingPolicy: string
): PricingStrategy => {
  const hamsPricingStrategy =
    HAMS_PRICING_STRATEGY_BY_CCP_PRICING_POLICY[
      ccpPricingPolicy as 'GRADUATED' | 'VOLUME'
    ];

  if (!hamsPricingStrategy) {
    throw new Error(
      `Could not find HAMS pricing strategy to match CCP pricing policy: "${ccpPricingPolicy}"`
    );
  }

  return hamsPricingStrategy;
};

const convertCCPTiersToHAMS = (
  ccpTiers: CCPPricingPlanTier[],
  tiersMode: string,
  chargeElement: string,
  currency: string
): PricingTier[] =>
  ccpTiers.map((ccpTier) => ({
    starter: false,
    pricingStrategy: convertCCPPricingStrategyToHAMS(tiersMode),
    unitDescription: chargeElement,
    unitLimitLower: ccpTier.floor,
    unitLimitUpper: ccpTier.ceiling,
    prices: [
      {
        currency,
        unitPrice:
          tiersMode === 'GRADUATED' ? ccpTier.unitAmount : ccpTier.flatAmount
      }
    ]
  }));

const convertCCPPricingPlansToHAMS = (
  pricingPlans: CCPPricingPlanContent[]
): PricingPlans => {
  const [monthlyCCP, annualCCP] = ['MONTH', 'YEAR'].map((primaryCycle) =>
    pricingPlans.find(
      (pricingPlan) => pricingPlan.primaryCycle_interval === primaryCycle
    )
  );

  const [monthly, annual] = [monthlyCCP, annualCCP].map((ccpPPContent) => {
    if (!ccpPPContent) {
      return undefined;
    }

    const ccpTiers = ccpPPContent.items[0] as CCPPricingPlanItem;
    const { tiers, tiersMode, chargeElement } = ccpTiers;

    return convertCCPTiersToHAMS(
      tiers,
      tiersMode,
      chargeElement,
      ccpPPContent.currency
    );
  });

  return {
    [PricingPeriod.MONTHLY]: monthly as PricingPlan,
    [PricingPeriod.ANNUAL]: annual as PricingPlan
  };
};

export { convertCCPPricingPlansToHAMS };
